import React from "react"
import { Container, Row, Col } from "reactstrap"
import Copyright from "../Copyright"

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
            <Col md={6}><Copyright/></Col>
            <Col md={6}>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  )
}

export default Footer
